import { commaListSchema } from "@birdwatch/common";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { z } from "zod";

import { APP_ROUTERS } from "@/constants/app-routers";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  planKey: z.string().optional(),
  discountCode: z.string().optional(),
  addOns: commaListSchema,
  referId: z.string().optional(),
  referredBy: z.string().optional(),
  ...maskSearchFragment,
});

function RouteComponent() {
  const { checkoutId } = Route.useParams();
  return (
    <Navigate
      to={APP_ROUTERS.MY_PLACES}
      search={(prev) => ({
        ...prev,
        checkoutId,
        addOns: (prev as { addOns?: string[] })?.addOns || [],
      })}
      replace
    />
  );
}

export const Route = createFileRoute(
  "/(member)/(protected)/my/checkout/$checkoutId",
)({
  validateSearch: searchSchema,
  component: RouteComponent,
});
